module.exports = __webpack_public_path__ + "media/amp_version/twitter-36f115d5.svg";